import type { ReactNode } from 'react';

type TooltipProperties = {
  children: ReactNode;
  content: ReactNode;
};

export const Tooltip = ({ children, content }: TooltipProperties) => (
  <span className="group relative inline-flex">
    {children}
    <span
      className="bg-ink text-raised shadow-raised pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 hidden max-w-64 -translate-x-1/2 rounded-md px-2.5 py-1.5 text-xs group-focus-within:block group-hover:block"
      role="tooltip"
    >
      {content}
    </span>
  </span>
);
